import strings from 'utils/strings.js'

export const lsIsTransmission = (ls) => ls === '13' || ls === '15'
export const lsIsSmartPlex = (ls) =>
  Number(ls) === SLOT_TYPES.SMARTPLEX ||
  ls.startsWith('DYNAMIC SMPLX INPUTREAD')
export const lsIsIgnition = (ls) => Number(ls) === SLOT_TYPES.IGNITION
export const lsIsIgnitionOrSmartPlex = (ls) => {
  const nls = Number(ls)
  return nls === SLOT_TYPES.IGNITION || nls === SLOT_TYPES.SMARTPLEX
}

// incomplete
export const SLOT_TYPES = {
  IGNITION: 120,
  SMARTPLEX: 550,
}

export const IGNITION_VALUES = Object.freeze([
  strings.off, // 0
  strings.acc_bit_label,
  strings.ign_bit_label, // run
  strings.crank_bit_label,
  // strings.error, // 4, how is this used elsewhere?  Just for error state display?
])

// export const ignitionValues = enumToSelectMenu(IGNITION_VALUES) // removing extra value conversion
export const ignitionValues = IGNITION_VALUES

// TODO: refactor to approx. above pattern.
const r = 'Reverse'
const n = 'Neutral'
const one = 'Gear 1'
const two = 'Gear 2'
const three = 'Gear 3'
const four = 'Gear 4'
const five = 'Gear 5'
const six = 'Gear 6'
const p = 'Park'
const u = 'Unavailable'

export const gearValues = [
  {
    title: r,
    key: r,
    value: '124',
  },
  {
    title: n,
    key: n,
    value: '125',
  },
  {
    title: one,
    key: one,
    value: '126',
  },
  {
    title: two,
    key: two,
    value: '127',
  },
  {
    title: three,
    key: three,
    value: '128',
  },
  {
    title: four,
    key: four,
    value: '129',
  },
  {
    title: five,
    key: five,
    value: '130',
  },
  {
    title: six,
    key: six,
    value: '131',
  },
  {
    title: p,
    key: p,
    value: '251',
  },
  {
    title: u,
    key: u,
    value: '',
  },
]

export function getSemanticGearValue(apiVal) {
  switch (apiVal) {
    case '124':
      return r
    case '125':
      return n
    case '126':
      return one
    case '127':
      return two
    case '128':
      return three
    case '129':
      return four
    case '130':
      return five
    case '131':
      return six
    case '251':
      return p
    default:
      return u
  }
}

export function getGearApiRepresentation(semanticVal) {
  switch (semanticVal) {
    case r:
      return '124'
    case n:
      return '125'
    case one:
      return '126'
    case two:
      return '127'
    case three:
      return '128'
    case four:
      return '129'
    case five:
      return '130'
    case six:
      return '131'
    case p:
      return '251'
    default:
      return u
  }
}

export const getGearValue = (val, op) => {
  switch (op) {
    case '2':
      return getEqualityOp(val)
    case '3':
      return getEqualityOp(val, true)
    case '4':
      return getGreaterThanOp(val)
    case '5':
      return getLessThanOp(val)
    case '6':
      return getGreaterThanEqualTo(val)
    case '7':
      return getLessThanEqualToOp(val)
    default:
  }
}

export const lsIsTimer = (output) => {
  const { ls, isTimer } = output
  return (
    isTimer || ls.includes('TIMER') || (Number(ls) >= 151 && Number(ls) <= 160)
  )
}

const getEqualityOp = (val, notEqual) => {
  let semantic

  switch (val) {
    case '124':
      semantic = r
      break
    case '125':
      semantic = n
      break
    case '126':
      semantic = one
      break
    case '127':
      semantic = two
      break
    case '128':
      semantic = three
      break
    case '129':
      semantic = four
      break
    case '130':
      semantic = five
      break
    case '131':
      semantic = six
      break
    case '251':
      semantic = p
      break
    case '65535':
      semantic = u
      break
    default:
      semantic = 'N/A'
  }

  return `is ${notEqual ? 'not' : ''} ${
    semantic !== u ? 'in' : ''
  } ${semantic} (${val})`
}

const getGreaterThanOp = (val) => {
  switch (val) {
    case '124':
      return `is in ${n}, gear, ${p} or ${u}`
    case '125':
      return `is in ${one} or higher, ${p} or ${u}`
    case '126':
      return `is in ${two} or higher, ${p} or ${u}`
    case '127':
      return `is in ${three} or higher, ${p} or ${u}`
    case '128':
      return `is in ${four} or higher, ${p} or ${u}`
    case '129':
      return `is in ${five} or higher, ${p} or ${u}`
    case '130':
      return `is in ${six} or higher, ${p} or ${u}`
    case '131':
      return `is in ${p} or ${u}`
    case '251':
      return `is ${u}`
    default:
      return `is ${u}`
  }
}

const getGreaterThanEqualTo = (val) => {
  switch (val) {
    case '124':
      return `is in ${r}, ${n}, gear, ${p} or ${u}`
    case '125':
      return `is in ${n}, gear, ${p} or ${u}`
    case '126':
      return `is in ${one} or higher, ${p} or ${u}`
    case '127':
      return `is in ${two} or higher, ${p} or ${u}`
    case '128':
      return `is in ${three} or higher, ${p} or ${u}`
    case '129':
      return `is in ${four} or higher, ${p} or ${u}`
    case '130':
      return `is in ${five} or higher, ${p} or ${u}`
    case '131':
      return `is in ${five} or higher, ${p} or ${u}`
    case '251':
      return `is in ${p} or ${u}`
    default:
      return `is ${u}`
  }
}

const getLessThanOp = (val) => {
  switch (val) {
    case '125':
      return `is in ${r}`
    case '126':
      return `is in ${n} or ${r}`
    case '127':
      return `is in ${one}, ${n} or ${r}`
    case '128':
      return `is in ${two} or lower, ${n} or ${r}`
    case '129':
      return `is in ${three} or lower, ${n} or ${r}`
    case '130':
      return `is in ${four} or lower, ${n} or ${r}`
    case '131':
      return `is in ${five} or lower, ${n} or ${r}`
    case '251':
      return `is in gear, ${n} or ${r}`
    case '65535':
      return `is in ${p}, gear, ${n} or ${r}`
    default:
      return `N/A`
  }
}

const getLessThanEqualToOp = (val) => {
  switch (val) {
    case '124':
      return `is in ${r}`
    case '125':
      return `is in ${n} or ${r}`
    case '126':
      return `is in ${one}, ${n} or ${r}`
    case '127':
      return `is in ${two}, ${n} or ${r}`
    case '128':
      return `is in ${three} or lower, ${n} or ${r}`
    case '129':
      return `is in ${four} or lower, ${n} or ${r}`
    case '130':
      return `is in ${five} or lower, ${n} or ${r}`
    case '131':
      return `is in ${six} or lower, ${n} or ${r}`
    case '251':
      return `is in ${p}, gear, ${n} or ${r}`
    case '65535':
      return `is in ${p}, gear, ${n}, ${r} or ${u}`
    default:
      return `N/A`
  }
}
